<template>
    <div class="container-fluid">
        <admin-header :name="$t(headerTitle)" @create="newBooking" :add-new="addNewBtn"/>
        <router-view name="booking" />
    </div>
</template>

<script>
export default {
    computed: {
        addNewBtn() {
            return this.$route.fullPath == '/auth/booking' || this.$route.fullPath == '/auth/booking/';
        },
        headerTitle() {
            if (this.$route.fullPath == '/auth/booking' || this.$route.fullPath == '/auth/booking/') {
                return 'Bookings';
            } else if(this.$route.fullPath == '/auth/booking/create') {
                return 'New booking';
            } else if(this.$route.fullPath.match('edit')) {
                return 'Edit booking';
            }
            return 'Bookings';
        }
    },
    methods: {
        newBooking() {
            this.$router.push({name:'booking.create'});
        }
    },
    metaInfo() {
        return {
            title: this.$t('Bookings')
        };
    }
};
</script>
